import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Lock, Sparkles } from 'lucide-react';

/**
 * Reusable popup shown when a user hits a plan-tier limit
 * (e.g. property cap, 5-vendor-with-docs cap on the Limited Demo tier).
 */
export const UpgradeDialog = ({ open, onClose, title, message }) => {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent data-testid="upgrade-limit-dialog">
        <DialogHeader>
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/15 mb-3">
            <Lock className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle
            data-testid="upgrade-limit-title"
            style={{ fontFamily: 'Space Grotesk, sans-serif' }}
          >
            {title || 'Plan Limit Reached'}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground" data-testid="upgrade-limit-message">
          {message || 'You have reached the limit for your current plan. Upgrade to unlock more.'}
        </p>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={onClose} data-testid="upgrade-limit-dismiss-button">
            Maybe Later
          </Button>
          <Button
            onClick={() => { onClose(); navigate('/profile'); }}
            data-testid="upgrade-limit-upgrade-button"
          >
            <Sparkles className="mr-2 h-4 w-4" /> Upgrade Plan
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeDialog;
